export default function multiClass(...classes) {
  return classes
    .filter(className => !!className) // remove falsy references
    .join(' ')
}
